import { BasicFilters } from "../basic-filters"
import { DDL } from "../ddl";

export class ActionFilters extends BasicFilters{
      public ActionUsers: DDL[] = [];
        constructor(values: Object = {}) {
            super();
            Object.assign(this, values);
            if (values.hasOwnProperty('ActionUsers')) {
                this.ActionUsers = [];
                ((values as ActionFilters)['ActionUsers'] as DDL[]).forEach(element => {
                    this.ActionUsers.push(new DDL(element));
                });
            }
        }
}